module.exports = __webpack_public_path__ + "img/brand_05.4ecfcecb.png";